




















import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

const cssPrefix = 'sw-widget-footer';

@Component({
  components: {},
})

export default class SwWidgetFooter extends SwExtendedVue {
  cssPrefix = cssPrefix;
}
